"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteTotalConfig = exports.tokenIsQuoteTotalToken = void 0;
var react_1 = __importDefault(require("react"));
var server_1 = __importDefault(require("react-dom/server"));
var QuoteTotal_1 = __importDefault(require("@CommonFrontend/Public/Widgets/QuoteTotal"));
var lodash_1 = require("lodash");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var Helpers_1 = require("@CommonFrontendBackend/Quote/Helpers");
var CommonWidgetRegistry_css_1 = require("../CommonWidgetRegistry.css");
var tokenIsQuoteTotalToken = function (token) {
    return token.type === "block" && token.subType === "quoteTotal";
};
exports.tokenIsQuoteTotalToken = tokenIsQuoteTotalToken;
exports.QuoteTotalConfig = {
    type: "quoteTotal",
    tokenType: {},
    publicRenderHtmlString: function (_a) {
        var attributes = _a.attributes, token = _a.token, blockId = _a.blockId, quoteContext = _a.quoteContext;
        (0, tiny_invariant_1.default)(blockId, "block ID was undefined");
        (0, tiny_invariant_1.default)(quoteContext, "no quote context was available when rendering total");
        var total = (0, lodash_1.omit)(token, ["type", "subType"]);
        var price = (0, Helpers_1.getPriceSummaryTotalForItem)(quoteContext.priceSummary, total.totalFor === "block" ? blockId : undefined);
        return server_1.default.renderToString(react_1.default.createElement(QuoteTotal_1.default, {
            attributes: attributes,
            total: total,
            price: price,
            blockId: blockId,
            accountQuoteSettings: quoteContext.accountQuoteSettings,
            quoteLabelSetId: quoteContext.quoteLabelSetId,
            projectCurrency: quoteContext.projectCurrency,
            priceSummary: quoteContext.priceSummary
        }));
    },
    traits: {
        widgetId: {},
        alignable: {
            defaultAlignment: "center"
        },
        selection: {
            ringMode: "hugging",
            ringBorderRadius: 8,
        },
        spacingShim: {
            className: CommonWidgetRegistry_css_1.quoteTotalSpacingShim
        }
    },
};
